import React from "react";
import { Select } from "antd";
import { CatalogueI, ClientI, ParameterI } from "../../../../libs/interfaces";

const { Option } = Select;

interface FiltersSectionProps {
  isAdmin: boolean;
  clients: ClientI[];
  typeEquipments: CatalogueI[];
  statusEquipments: ParameterI[];
  handleSelectClient: (client: number | null) => void;
  clientSelected: number | null;
  onFilterChange: any;
  filters: any;
  typeEquipment: number | null;
  handleSelectTypeEquipment: (type: number | null) => void;
}

const FiltersSection = ({
  isAdmin,
  clients,
  typeEquipments,
  statusEquipments,
  handleSelectClient,
  clientSelected,
  filters,
  onFilterChange,
  typeEquipment,
  handleSelectTypeEquipment,
}: FiltersSectionProps) => {
  return (
    <div className="filters-section">
      <div className="filters-grid">
        {/* <div className="filter-group">
          <label htmlFor="dateRange">Período</label>
          <Select
            id="dateRange"
            value={filters.dateRange}
            onChange={(value) => onFilterChange("dateRange", value)}
            style={{ width: "100%" }}
            allowClear
            showSearch
            filterOption={(input, option) =>
              (option?.children as any)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            <Option value="7days">Últimos 7 días</Option>
            <Option value="30days">Últimos 30 días</Option>
            <Option value="3months">Últimos 3 meses</Option>
            <Option value="6months">Últimos 6 meses</Option>
            <Option value="1year">Último año</Option>
            <Option value="all">Todo el tiempo</Option>
          </Select>
        </div>

        <div className="filter-group">
          <label htmlFor="status">Estado</label>
          <Select
            id="status"
            value={filters.status}
            onChange={(value) => onFilterChange("status", value)}
            style={{ width: "100%", maxWidth: 250 }}
            allowClear
            showSearch
            filterOption={(input, option) =>
              (option?.children as any)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            <Option value={null}>Todos</Option>
            {statusEquipments.map((status) => (
              <Option key={status.id} value={status.id!}>
                {status.value}
              </Option>
            ))}
          </Select>
        </div> */}

        {isAdmin && (
          <div className="filter-group">
            <label htmlFor="client">Cliente</label>
            <Select
              id="client"
              value={clientSelected}
              onChange={(value) => {
                handleSelectClient(value);
              }}
              style={{ width: "100%", maxWidth: 250 }}
              allowClear
              showSearch
              placeholder="Buscar cliente..."
              filterOption={(input, option) => {
                // Buscar por el nombre del cliente (children del Option)
                const clientName = option?.children as any;
                return clientName.toLowerCase().includes(input.toLowerCase());
              }}
              optionFilterProp="children"
            >
              <Option value={null}>Todos los clientes</Option>
              {clients.map((client) => (
                <Option key={client.id} value={client.id!}>
                  {client.name}
                </Option>
              ))}
            </Select>
          </div>
        )}

        <div className="filter-group">
          <label htmlFor="assetType">Tipo de Activo</label>
          <Select
            id="assetType"
            value={typeEquipment}
            onChange={handleSelectTypeEquipment}
            style={{ width: "100%", maxWidth: 250 }}
            allowClear
            showSearch
            filterOption={(input, option) =>
              (option?.children as any)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            <Option value={null}>Todos los tipos</Option>
            {typeEquipments.map((type) => (
              <Option key={type.id} value={type.id!}>
                {type.name}
              </Option>
            ))}
          </Select>
        </div>
      </div>
    </div>
  );
};

export default FiltersSection;
